import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Common Application Pipes
import { TranslatePipe } from './translate.pipe';
import { TruncatePipe } from './truncate.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { CleanTextPipe } from './clean-text.pipe';
import { SafeContentPipe } from './safe-content.pipe';
import { BackorderedDatePipe } from './backordered-date.pipe';
import { ThumbnailPipe } from './thumbnail.pipe';
import { NewLineReplacePipe } from './new-line-replace.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    TranslatePipe,
    TruncatePipe,
    DateFormatPipe,
    CleanTextPipe,
    BackorderedDatePipe,
    SafeContentPipe,
    ThumbnailPipe,
    NewLineReplacePipe,
  ],
  exports: [
    TranslatePipe,
    TruncatePipe,
    DateFormatPipe,
    BackorderedDatePipe,
    CleanTextPipe,
    SafeContentPipe,
    ThumbnailPipe,
    NewLineReplacePipe,
  ],
  providers: [DateFormatPipe],
})
export class PipesModule {}
